"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookmarksProvider = exports.BookmarksContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EpubReaderContext = require("./EpubReaderContext");
var _services = require("../services");
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable no-console */ // Contexts
// Services
var BookmarksContext = exports.BookmarksContext = /*#__PURE__*/(0, _react.createContext)();
var BookmarksProvider = _ref => {
  var {
    children
  } = _ref;
  var {
    cfi,
    getChapterName,
    applicationToken,
    sessionToken,
    userId,
    uuid,
    rendition,
    bookTitle
  } = (0, _react.useContext)(_EpubReaderContext.EpubReaderContext);
  var service = (0, _services.BookmarksService)(applicationToken, sessionToken);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var trackService = (0, _services.TrackingsService)(appToken, sessionToken);
  var [bookmarks, setBookmarks] = (0, _react.useState)([]);
  var [isPageBookmarked, setIsPageBookmarked] = (0, _react.useState)(false);
  function deleteUserBookmark() {
    var bookmarkId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var bookmarkToRemove;
    if (bookmarkId) {
      [bookmarkToRemove] = bookmarks.filter(bookmark => bookmark.id === bookmarkId);
    } else {
      [bookmarkToRemove] = bookmarks.filter(bookmark => bookmark.cfi === cfi);
    }
    service.deleteUserBookmark(bookmarkToRemove.id);
  }
  function createUserBookmark(_x) {
    return _createUserBookmark.apply(this, arguments);
  }
  /* ------- Exported functions (through context) ------ */
  function _createUserBookmark() {
    _createUserBookmark = _asyncToGenerator(function* (chapterName) {
      var {
        startContainer: {
          textContent
        }
      } = yield rendition.getRange(cfi);
      var response;
      try {
        response = yield service.createUserBookmark({
          book_id: uuid,
          user_id: userId,
          page_reference: cfi,
          chapter_name: chapterName,
          summary: textContent
        });
        if (!response.ok) {
          response = null;
        }
      } catch (e) {
        // SEND TO BUGSNAG
        response = null;
      }
      return response;
    });
    return _createUserBookmark.apply(this, arguments);
  }
  function handleUserBookmark() {
    return _handleUserBookmark.apply(this, arguments);
  }
  function _handleUserBookmark() {
    _handleUserBookmark = _asyncToGenerator(function* () {
      var newBookmarksList;
      var {
        textContent
      } = rendition.getRange(cfi).startContainer;
      var shortenTextContent = textContent.trim().substring(0, 50);
      var chapterName = getChapterName(cfi) || shortenTextContent || bookTitle;
      if (isPageBookmarked) {
        deleteUserBookmark();
        newBookmarksList = bookmarks.filter(bookmark => bookmark.cfi !== cfi);
        setIsPageBookmarked(false);
      } else {
        var response = yield createUserBookmark(chapterName);
        if (response) {
          var result = yield response.json();
          var {
            data
          } = result;
          trackService.trackBookmark({
            uuid,
            titleCover: bookTitle,
            bookmark: data.id,
            chapter: chapterName
          });
          bookmarks.push({
            id: data.id,
            cfi: data.page_reference,
            chapterName,
            summary: data.summary
          });
        }
        newBookmarksList = bookmarks;
        setIsPageBookmarked(true);
      }
      setBookmarks(newBookmarksList);
    });
    return _handleUserBookmark.apply(this, arguments);
  }
  function removeBookmark(_x2) {
    return _removeBookmark.apply(this, arguments);
  }
  function _removeBookmark() {
    _removeBookmark = _asyncToGenerator(function* (bookmarkId) {
      deleteUserBookmark(bookmarkId);
      setIsPageBookmarked(false);
      var newBookmarksList = bookmarks.filter(bookmark => bookmark.id !== bookmarkId);
      setBookmarks(newBookmarksList);
    });
    return _removeBookmark.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(BookmarksContext.Provider, {
    value: {
      bookmarks,
      setBookmarks,
      removeBookmark,
      isPageBookmarked,
      handleUserBookmark,
      setIsPageBookmarked
    }
  }, children);
};
exports.BookmarksProvider = BookmarksProvider;
BookmarksProvider.propTypes = {
  children: _propTypes.default.node.isRequired
};